import { Injectable } from '@angular/core';
import { GetLoyaltyCollectionsResponseDto } from '@src/api';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class LpAllCollectionsStoreService extends BaseStoreService<GetLoyaltyCollectionsResponseDto[]> {}
